import { FC } from "react";

export const Card: FC<{ children: React.ReactNode, title: string, label?: string }> = ({ children, title, label }) => {
  return <div className={"bg-white text-black rounded-sm my-4 border border-slate-100"}>
    <header className={"py-4 px-6 border-b border-slate-200 font-medium"}>
      {title}
      {label && <span className={"text-xs uppercase text-brand-900 bg-brand-100 px-2 py-1 mx-3 rounded-sm"}>{label}</span>}
    </header>
    <div className={"py-4 px-6"}>
      {children}
    </div>
  </div>
}
